import script from "./RequestAccountView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RequestAccountView.vue?vue&type=script&lang=ts&setup=true"

import "./RequestAccountView.vue?vue&type=style&index=0&id=6af95509&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af95509"]])

export default __exports__